const localeFiles = {};

function importAll(r) {
  r.keys().forEach((key) => (localeFiles[key] = r(key)));
}

const terms = require.context(".", true, /\.lang\.json/, 'eager');
importAll(terms)

export default localeFiles;
